import moment from "moment";
export var absoluteMinimumDate = new Date(1970, 0, 1);
export var absoluteMaximumDate = new Date(2999, 1, 1);
export function reasonableMinimumDate(year) {
    return new Date(year - 1, 0, 1); // month is 0-indexed
}
export function reasonableMaximumDate(year) {
    return new Date(year + 5, 11, 31);
}
/**
 * Parses a string-based date out of a Date.
 * Returns the string in format m.yyyy
 * @param date Date.
 */
export function parseString(date) {
    return date.getMonth() + 1 + "." + date.getFullYear();
}
/**
 * Parses a string-based date out of a Date.
 * Returns the string in format d.m.yyyy
 * @param date Date.
 */
export function parseFullString(date) {
    return date.getDate() + "." + (date.getMonth() + 1) + "." + date.getFullYear();
}
/**
 * Parses a Date instance out of a string-based date.
 * Assumes that string based-date is given in format m|mm.yyyy or d|dd.mm.yyyy
 * @param value String-based date
 */
export function parseDate(value) {
    var date = undefined;
    if (!value)
        return date;
    var valueArray = value.split(".");
    if (valueArray.length == 2) {
        date = parseMMYYYY(valueArray);
    }
    else if (valueArray.length == 3 && valueArray[2].length == 4) {
        date = parseDDMMYYYY(valueArray);
    }
    return date;
}
function parseMMYYYY(valueArray) {
    if (valueArray[1].length != 4) {
        throw new Error("Expecting date in format MM.YYYY");
    }
    valueArray[0] = valueArray[0].padStart(2, "0");
    return new Date(valueArray[1] + "-" + valueArray[0]);
}
function parseDDMMYYYY(valueArray) {
    if (valueArray[2].length != 4) {
        throw new Error("Expecting date in format DD.MM.YYYY");
    }
    valueArray[0] = valueArray[0].padStart(2, "0");
    valueArray[1] = valueArray[1].padStart(2, "0");
    return moment(valueArray[2] + "-" + valueArray[1] + "-" + valueArray[0]).toDate();
}
